import {combineReducers} from 'redux';
import {reducer as reduxForm} from 'redux-form';
import application from './application';
import disputes from './disputes';
import features from './features';

export const reducers = {
  application,
  disputes,
  features,
  form: reduxForm
};

const rootReducer = combineReducers(reducers);

export default rootReducer;
